import * as React from 'react';
import { cn } from '../lib/utils';

interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: number;
  max?: number;
  color?: 'blue' | 'green' | 'purple' | 'orange' | 'red' | 'yellow';
  size?: 'sm' | 'md' | 'lg';
}

const progressColors = {
  blue: 'bg-primary',
  green: 'bg-success',
  purple: 'bg-info',
  orange: 'bg-warning',
  red: 'bg-error',
  yellow: 'bg-warning',
};

const progressSizes = {
  sm: 'h-1',
  md: 'h-2',
  lg: 'h-3',
};

const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ className, value = 0, max = 100, color = 'blue', size = 'md', ...props }, ref) => {
    const percentage = Math.min(Math.max((value / max) * 100, 0), 100);

    return (
      <div
        ref={ref}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={max}
        aria-valuenow={value}
        className={cn(
          'bg-muted relative w-full overflow-hidden rounded-full',
          progressSizes[size],
          className
        )}
        {...props}
      >
        <div
          className={cn('h-full transition-all duration-300 ease-in-out', progressColors[color])}
          style={{ width: `${String(percentage)}%` }}
        />
      </div>
    );
  }
);
Progress.displayName = 'Progress';

export { Progress, type ProgressProps };
